import { render, staticRenderFns } from "./Decisions.vue?vue&type=template&id=6d4db6a5&scoped=true&"
import script from "./Decisions.vue?vue&type=script&lang=js&"
export * from "./Decisions.vue?vue&type=script&lang=js&"
import style0 from "./Decisions.vue?vue&type=style&index=0&id=6d4db6a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4db6a5",
  null
  
)

export default component.exports